import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Services from '../components/ServicesSection';
import Projects from '../components/ProjectsSection';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';

function Home() {
  return (
    <>
      <Helmet>
        <title>Professional Construction Services | BuildCorp - Quality Building Solutions</title>
        <meta name="description" content="BuildCorp offers professional construction services including residential, commercial building, renovation, and project management. 20+ years of construction excellence." />
        <meta name="keywords" content="construction company, building services, residential construction, commercial construction, renovation, project management" />
      </Helmet>
      
      <Hero />
      <Services />
      <Projects />
      <Stats />
      <Testimonials />
    </>
  );
}

export default Home;